<script setup>
  import { ref, reactive, computed, onMounted, defineComponent, defineExpose, defineEmits } from 'vue'
  import { userInfoStore, rewardListStore } from '@/stores/counter.js'
  import { Swiper, SwiperSlide } from 'swiper/vue'
  import 'swiper/css'
  import "swiper/css/navigation";
  import { Navigation, Mousewheel } from 'swiper/modules';

  import rw01 from "@/assets/img/02p/rw01m-m.png"
  import jn01 from "@/assets/img/02p/jn01.png"
  import name01 from "@/assets/img/02p/name01.png"
  import audio01 from "@/assets/img/02p/rwmp01.mp3"
  import rw02 from "@/assets/img/02p/rw02-m.png"
  import jn02 from "@/assets/img/02p/jn02.png"
  import name02 from "@/assets/img/02p/name02.png"
  import audio02 from "@/assets/img/02p/rwmp02.mp3"
  import rw03 from "@/assets/img/02p/rw03-m.png"
  import jn03 from "@/assets/img/02p/jn03.png"
  import name03 from "@/assets/img/02p/name03.png"
  import audio03 from "@/assets/img/02p/rwmp03.mp3"
  import rw04 from "@/assets/img/02p/rw04-m.png"
  import jn04 from "@/assets/img/02p/jn04.png"
  import name04 from "@/assets/img/02p/name04.png"
  import audio04 from "@/assets/img/02p/rwmp04.mp3"
  import rw05 from "@/assets/img/02p/rw05-m.png"
  import jn05 from "@/assets/img/02p/jn05.png"
  import name05 from "@/assets/img/02p/name05.png"
  import audio05 from "@/assets/img/02p/rwmp05.mp3"

  const modules = ref([Navigation, Mousewheel])
  const ElementSwiper = defineComponent(Swiper)
  const ElementSwiperSlide = defineComponent(SwiperSlide)
  const sildeIndex = ref(0)

  const userStore = userInfoStore()
  const rewardStore = rewardListStore()
  const userInfo = computed(() => {
    return userStore.userInfo
  })

  const swiperInstance = ref(null);
  const progressArr = ref([
    { id: 0, icon: rw01, name: name01, qIcon: jn01, audio: audio01 },
    { id: 1, icon: rw02, name: name02, qIcon: jn02, audio: audio02 },
    { id: 2, icon: rw03, name: name03, qIcon: jn03, audio: audio03 },
    { id: 3, icon: rw04, name: name04, qIcon: jn04, audio: audio04 },
    { id: 4, icon: rw05, name: name05, qIcon: jn05, audio: audio05 },
  ])
  const configData = ref('')
  
  const onSwiper = (swp) => {
    console.log('【swp】', swp, swp.slideNext, swp.slidePrev);
    swiperInstance.value = swp
  }
  const onSlideChange = (index) => {
    console.log('【index角色】', index.activeIndex);
  }
  const slidePrev = (data) => {
    console.log('【当前1】', data);
    if (data.id == 0) {
      console.log('【回到第一个】');
      sildeIndex.value = 4
      audioPlay()
    } else {
      sildeIndex.value = data.id - 1
      audioPlay()
    }
    if (swiperInstance.value) {
      swiperInstance.value.slidePrev()
    }
  }
  const slideNext = (data) => {
    console.log('【当前2】', data);
    if (data.id == 4) {
      console.log('【回到第一个】');
      sildeIndex.value = 0
      audioPlay()
    } else {
      sildeIndex.value = data.id + 1
      audioPlay()
    }
    if (swiperInstance.value) {
      swiperInstance.value.slideNext()
    }
  }

  const emit = defineEmits(['needLogin', 'goPayPage'])
  const showAppoPopchild = () => {
    emit('needLogin');
  }
  const goPay = () => {
    console.log('【跳转】');
    
    emit('goPayPage')
  }
  const toAppStor = () => {
    window.location.href = configData.value.download[1].value
  }
  const toGgStor = () => {
    window.location.href = configData.value.download[0].value
  }
  const audioPlay = () => {
    const idText = 'audioMp' + sildeIndex.value
    console.log('【播放音频】', idText);
    if (document.getElementById(idText)) {
      document.getElementById(idText).play()
    }
  }
  
  
  defineExpose({ audioPlay })
  onMounted(() => {
    if (localStorage.getItem('config-record')) {
      configData.value = JSON.parse(localStorage.getItem('config-record'))
    }
  })
</script>

<template>
  <section class="content-box">
    <video
      src="@/assets/img/02p/bac.mp4"
      poster="@/assets/img/02p/bac.jpg"
      :autoplay="true"
      muted="muted"
      loop="loop"
      :playsinline="true"
      style="width: 100%; height: 100%; object-fit: cover;"
    >
    </video>
    <section style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center;">
      <img src="@/assets/img/02p/title01m.png" alt="" style="height: 0.7rem; margin-top: 1.36rem;">
      <section style="flex: 1; width: 100%;">
        <ElementSwiper
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          :slides-per-view="1"
          :modules="modules"
          :space-between="0"
          :direction="'horizontal'"
          :loop="true"
          style="width: 100%; height: 100%;"
        >
          <ElementSwiperSlide v-for="rwData in progressArr" :key="rwData.id" style="display: flex; flex-direction: column; align-items: center;">
            <aside class="rw-box">
              <img src="@/assets/img/02p/qie-left.png" alt="" @click="slidePrev(rwData)" style="height: 0.88rem; margin-right: 1.28rem;">
              <img :src="rwData.icon" alt="" style="height: 4.48rem;">
              <img src="@/assets/img/02p/qie-right.png" alt="" @click="slideNext(rwData)" style="height: 0.88rem; margin-left: 1.28rem;">
              <img :src="rwData.name" alt="" style="position: absolute; left: 0.48rem; bottom: 0.28rem; height: 0.8rem;">
              <!-- <audio src="@/assets/img/02p/rwmp01.mp3" autoplay></audio> -->
              <audio :id="'audioMp' + rwData.id">
                <source :src="rwData.audio" type="audio/mpeg">
              </audio>
            </aside>
            <aside class="jn-box">
              <img :src="rwData.qIcon" alt="" style="height: 2.56rem;">
            </aside>
          </ElementSwiperSlide>
        </ElementSwiper>
      </section>
    </section>
    
    <aside class="side-right">
      <img src="@/assets/img/01p/xz.png" alt="" style="height: 0.22rem; margin-bottom: 0.1rem;">
      <img v-if="configData" :src="configData.download[4].value" alt="" style="width: 1.36rem; margin-bottom: 0.2rem;">
      <img src="@/assets/img/01p/btn0201.png" alt="" @click="toAppStor" style="height: 0.45rem; margin-bottom: 0.1rem;">
      <img src="@/assets/img/01p/btn0202.png" alt="" @click="toGgStor" style="height: 0.45rem; margin-bottom: 0.1rem;">
      <img src="@/assets/img/01p/pay-btn.png" alt="" @click="goPay" style="height: 0.45rem;">
    </aside>
  </section>
</template>

<style scoped>
.content-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding-top: 60px; */
  height: 100%;
  background: url('../../assets/img/02p/bac.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  position: relative;
}
.rw-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  /* margin-top: 0.28rem; */
  margin-bottom: -0.42rem;
}
.jn-box {
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('../../assets/img/02p/jn-bac.png') no-repeat;
  background-size: 100% 100%;
  padding: 0.68rem 2rem 0.24rem;
  margin-top: -0.28rem;
}
.side-right {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: url('../../assets/img/01p/side-r-bac.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.16rem 0.12rem 0.32rem;
  z-index: 9;
}
</style>
